<template>
  <BaseTable
    :headers="[
      $t('global.name'),
    ]"
    :rows="
      categories.map((category) => ({
        id: category.id,
      cells: [
        category.name
      ],
      actions: getActions()
    }))
    "
    @action="onAction"
    v-test="'productCategories'"
  ></BaseTable>
</template>

<script
  setup
  lang="ts"
>
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';

const { t } = useI18n();
const { hasFeatureFlag } = useUserStore();
const router = useRouter();

interface CategoryItem {
  id: number;
  name: string;
  amountProducts: number;
}

const categories = inject<Ref<CategoryItem[]>>('page-items');

const getActions = () => [
  {
    name: 'edit',
    icon: 'edit',
    label: t('global.actions.edit'),
  },
  ...(hasFeatureFlag('product-delete')
    ? [
        {
          name: 'delete',
          icon: 'delete',
          label: t('global.actions.delete'),
        },
      ]
    : []),
];

const onAction = ({ id, option }) => {
  const category = categories?.value.find((category) => category.id === id);
  if (option === 'edit') {
    router.push({
      name: 'products-edit-category',
      params: { id },
    });
  }

  if (option === 'delete') {
    router.push({
      name: 'products-delete-category',
      params: { id },
      query: {
        products: category.amountProducts,
      },
    });
  }
};
</script>
